import { create } from 'zustand';

/**
 * Read-only signal for "is the tour currently active?". TourProvider is the
 * single writer (via `setActive`); arbitrary consumers — modals that need to
 * suppress click-outside, components that want to skip a transient toast —
 * subscribe via `useTourStateStore(s => s.isActive)`.
 *
 * This exists separately from `useTour()` so consumers don't need a
 * `<TourProvider>` ancestor in tests / Storybook just to read the boolean.
 * The store defaults to `false` if nobody has set it yet.
 */
interface TourStateStore {
  isActive: boolean;
  setActive: (active: boolean) => void;
}

export const useTourStateStore = create<TourStateStore>()((set) => ({
  isActive: false,
  setActive: (active) => set({ isActive: active }),
}));
